<ng-container *ngFor="let unit of units">
  <div class="tech-tab-add-unit" *ngIf="!unit.active && unit.canAdd">
    <button mat-icon-button type="button" [disabled]="isReadOnly()" (click)="onAdd(unit)">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div class="tech-tab-unit" *ngIf="unit.active">
    <h4>
      {{unit.label}}
      <button *ngIf="unit.canDelete" mat-icon-button type="button" [disabled]="isReadOnly()" (click)="onDelete(unit)">
        <mat-icon>delete</mat-icon>
      </button>
    </h4>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="subTechnology"
                        [items]="allSubTechnologies"
                        [itemToLabel]="subTechToLabel"
                        placeholder="Sub-Technology"
                        tooltip=""
                        error="Mandatory: Please select a value"
    ></digires-list-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="manufacturer"
                        placeholder="Wind Turbine Manufacturer"
                        tooltip="The name of the manufacturer of the Wind Turbines that it is proposed to install
                          in this Project as set out in the preferred scenario in the financial model. As the
                          project evolves through the development process the Wind Turbine Manufacturer may change
                          as the project matures and more information is available to the project team."
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="modelType"
                        placeholder="Wind Turbine Model Type"
                        tooltip="The name of the model (and if applicable variant type) of the Wind Turbines that
                          it is proposed to install in this Project as set out in the preferred scenario in the
                          financial model. As the project evolves through the development process the Wind Turbine
                          Model Type may change as the project matures and more information is available to the
                          project team."
    ></digires-text-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="count"
                       placeholder="Number of Wind Turbines"
                       error="Please enter a whole number between 0 and 999"
                       tooltip="The number of Wind Turbines that it is proposed to install in this Project as set
                         out in the preferred scenario in the financial model. As the project evolves through the
                         development process the number of turbines may fluctuate as the layout changes."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="capacity"
                       placeholder="Wind Turbine Installed Capacity (MW)"
                       error="Please enter a positive number"
                       tooltip="The installed capacity of the Wind Turbine model that it is proposed to install
                         in this Project as set out in the preferred scenario in the financial model. This relates
                         to the capacity of each wind turbine and not the total capacity of the project as a whole.
                         Installed Capacity expressed in megawatts (MW). As the project evolves through the
                         development process the installed capacity may fluctuate if the Wind Turbine Model Type is
                         changed as the project matures and more information is available to the project team."
    ></digires-num-input>

    <digires-num-input [formGroup]="formGroup"
                       [finModel]="financialModelReadManager"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="totalCapacity"
                       [readOnly]="true"
                       readOnlyReason="{{calculatedReadOnlyReason}}"
                       placeholder="Total Capacity per Wind Turbine type (MW)"
                       tooltip="The total installed capacity of this type of wind turbine that is calculated by
                         multiplying the installed capacity of this type of Wind Turbine model by the number of Wind
                         Turbines of this type that it is proposed to install in this Project as set out in the
                         preferred scenario in the financial model. This relates to the total capacity of this type
                         of turbine wind turbine and not the total capacity of the project as a whole where there
                         may be additional turbine types being considered. Installed Capacity expressed in megawatts
                         (MW). The Type of wind turbine could be different variations (e.g. different hub heights)
                         of the same model or there could be completely different models from different
                         manufacturers. As the project evolves through the development process the installed
                         capacity may fluctuate if the Wind Turbine Model Type is changed as the project matures and
                         more information is available to the project team."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="tipHeight"
                       placeholder="Wind Turbine tip height (meters)"
                       error="Please enter a non-negative number"
                       tooltip="The height at the top of the rotor measured from ground level of the Wind Turbines
                         that it is proposed to install in this Project as set out in the preferred scenario in the
                         Financial Model. Height measured in metres. As the project evolves through the development
                         process the wind turbine tip height may change if the Wind Turbine Model Type is changed as
                         the project matures and more information is available to the project team."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="hubHeight"
                       placeholder="Wind Turbine hub height (meters)"
                       error="Please enter a non-negative number"
                       tooltip="The height at the centre of the hub measured from ground level of the Wind
                         Turbines that it is proposed to install in this Project as set out in the preferred
                         scenario in the financial model. Height measured in metres. As the project evolves through
                         the development process the wind turbine hub height may change if the Wind Turbine Model
                         Type is changed as the project matures and more information is available to the project
                         team."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="rotorDiameter"
                       placeholder="Wind Turbine - Rotor Diameter (m)"
                       error="Please enter a non-negative number"
                       tooltip="The diameter of the rotor of this type of Wind Turbine that it is proposed to
                         install in this Project as set out in the preferred scenario in the Financial Model.
                         Diameter measured in metres. The Type of wind turbine could be different variations (e.g.
                         different hub heights) of the same model or there could be completely different models
                         from different manufacturers. As the project evolves through the development process the
                         wind turbine hub height may change if the Wind Turbine Model Type is changed as the project
                         matures and more information is available to the project team."
    ></digires-num-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="manufacturerByPermit"
                        placeholder="Wind Turbine Manufacturer - According to Permit"
                        tooltip="The name of the manufacturer of the Wind Turbines that it is permitted to install in
                        this Project as set out in the permit for the project."
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="modelTypeByPermit"
                        placeholder="Wind Turbine Model Type - According to Permit"
                        tooltip="The name of the model (and if applicable variant type) of the Wind Turbines that it is
                        permitted to install in this Project as set out in the permit for the project."
    ></digires-text-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="capacityMaxByPermit"
                       placeholder="Wind Turbine Installed Capacity (MW) - Maximum according to Permit"
                       error="Please enter a non-negative number"
                       tooltip="The maximum installed capacity of the Wind Turbine model that it is permitted to
                       install in this Project as set out in the permit for the project."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="capacityMaxByPermitAmendment"
                       placeholder="Wind Turbine Installed Capacity (MW) - Maximum with Permit amendment"
                       error="Please enter a non-negative number"
                       tooltip="The maximum installed capacity of the Wind Turbine model that it is proposed to install
                       in this Project subject to an amendment to the permit for the project being permitted."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="tipHeightMaxByPermit"
                       placeholder="Wind Turbine Tip Height (metres) - Maximum according to Permit"
                       error="Please enter a non-negative number"
                       tooltip="The maximum height at the top of the rotor of the Wind Turbine as measured from ground
                       level that it is proposed to install in this Project as set out in the permit for the project."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="tipHeightMaxByPermitAmendment"
                       placeholder="Wind Turbine Tip Height (metres) - Maximum with Permit amendment"
                       error="Please enter a non-negative number"
                       tooltip="The maximum height at the top of the rotor of the Wind Turbine as measured from ground
                       level that it is proposed to install in this Project subject to an amendment to the permit for
                       the project being permitted."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="hubHeightMaxByPermit"
                       placeholder="Wind Turbine Hub Height (metres) - Maximum according to Permit"
                       error="Please enter a non-negative number"
                       tooltip="The maximum height at the centre of the hub of the Wind Turbine as measured from ground
                       level that it is proposed to install in this Project as set out in the permit for the project."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="hubHeightMaxByPermitAmendment"
                       placeholder="Wind Turbine Hub Height (metres) - Maximum with Permit amendment"
                       error="Please enter a non-negative number"
                       tooltip="The maximum height at the centre of the hub of the Wind Turbine as measured from ground
                       level that it is proposed to install in this Project subject to an amendment to the permit for
                       the project being permitted."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="rotorDiameterMaxByPermit"
                       placeholder="Wind Turbine Rotor Diameter (metres) - Maximum according to Permit"
                       error="Please enter a non-negative number"
                       tooltip="The maximum diameter of the rotor of the Wind Turbine that it is proposed to install in
                       this Project as set out in the permit for the project."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="rotorDiameterMaxByPermitAmendment"
                       placeholder="Wind Turbine Rotor Diameter (metres) - Maximum with Permit amendment"
                       error="Please enter a non-negative number"
                       tooltip="The maximum diameter of the rotor of the Wind Turbine that it is proposed to install in
                       this Project subject to an amendment to the permit for the project being permitted."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="rotorGroundClearanceMinByPermit"
                       placeholder="Wind Turbine Rotor Ground Clearance (metres) - Minimum according to Permit"
                       error="Please enter a non-negative number"
                       tooltip="The minimum distance between the bottom of the rotor of the Wind Turbine that it is
                       proposed to install in this Project and ground level as set out in the permit for the project."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="averageWindSpeed"
                       placeholder="Average wind speed at Wind Turbine hub height (m/s)"
                       error="Please enter a non-negative number"
                       tooltip="The average wind speed measured (preferred) or predicted at the hub height of the
                         Wind Turbines that it is proposed to install in this Project as set out in the preferred
                         scenario in the financial model, ideally taken from an AEP as prepared by Analytics &
                         Digital - Resource Assessment (A&D-RA) but in exceptional circumstances other sources of
                         data may be available although use of them should be discussed and agreed with A&D-RA.
                         Wind Speed measures in metres per second (m/s). As the project evolves through the
                         development process the wind turbine hub height may change if the Wind Turbine Model Type
                         is changed as the project matures and more information is available to the project team,
                         variations in hub height are likely to have different average wind speeds."
    ></digires-num-input>

  </div>
</ng-container>
